module.exports = __webpack_public_path__ + "static/media/YE.4bfaedbf.png";